var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFuture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14829_10229)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14829_10229",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 27,
    height: 27
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0488 5.01123H6.04883V31.0112H32.0488V5.01123Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14829_10229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0484 5.01123C16.4772 5.01123 13.9637 5.77368 11.8258 7.20217C9.68793 8.63066 8.02165 10.661 7.03769 13.0365C6.05373 15.412 5.79628 18.0259 6.2979 20.5477C6.79952 23.0695 8.03767 25.386 9.8558 27.2041C11.6739 29.0222 13.9903 30.2604 16.5122 30.762C19.034 31.2636 21.6479 31.0062 24.0234 30.0222C26.3989 29.0382 28.4292 27.372 29.8577 25.2341C31.2862 23.0962 32.0487 20.5827 32.0487 18.0115C32.0485 14.5637 30.6788 11.2571 28.2408 8.81909C25.8028 6.3811 22.4962 5.01138 19.0484 5.01123ZM19.9259 19.8047H11.9183V18.2046H18.3253V9.08996H19.9259V19.8047Z",
    fill: "#39D1EA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14829_10229"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(6.04883 5.01123)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFuture);
export default __webpack_public_path__ + "static/media/icon_future.4d89d7f0d51a696d6760bb63bf73bad9.svg";
export { ForwardRef as ReactComponent };